var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('notifications'),(
      _vm.$route.name !== 'Login' &&
      _vm.$route.meta.isFrontend === true &&
      _vm.$route.name !== 'EntityLink' &&
      _vm.$route.name !== 'EntityLinkHighlightedCard' &&
      _vm.$route.name !== 'ProspectingBuyers'
    )?_c('core-home-toolbar'):_vm._e(),(_vm.$route.name !== 'Login' && _vm.$route.meta.isFrontend !== true)?_c('core-drawer'):_vm._e(),_c('core-view',{staticStyle:{"position":"relative","margin-top":"20px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }